module.exports = __webpack_public_path__ + "assets/img/to_pic1.c7f2b2c0.jpg";